'use strict';

angular.module('AcaApp').controller('InvalidSessionController',
[
  '$scope',
  '$location',
  function($scope, $location){
    $scope.goLogin = function(){
      $location.path('/login');
    };
  }
]);
